import InfoTip from "./InfoTip";
import adminStyles from "../ui/AdminStyles";

const labelRowStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
};

/**
 * Label + InfoTip above a control.
 */
export function LabelWithTip({ label, tip, children, align, wide, style }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 12, ...style }}>
      <span style={labelRowStyle}>
        {label}
        <InfoTip text={tip} align={align} wide={wide} />
      </span>
      {children}
    </div>
  );
}

/**
 * Table header cell with InfoTip.
 */
export function ThWithTip({ children, tip, align, wide, style }) {
  return (
    <th style={{ ...adminStyles.th, ...style }}>
      <span style={labelRowStyle}>
        {children}
        <InfoTip text={tip} align={align} wide={wide} />
      </span>
    </th>
  );
}

/**
 * Inline label text + InfoTip (for checkboxes / compact rows).
 */
export function InlineTip({ label, tip, align, wide }) {
  return (
    <span style={labelRowStyle}>
      {label}
      <InfoTip text={tip} align={align} wide={wide} />
    </span>
  );
}
